module.exports = __webpack_public_path__ + "img/businesses.4727ca2b.png";